<rask-page pageTitle="Produktionsmål" noPadding>
  @if (validation) {
    <ng-container headerContent>
      <form name="form" id="form" role="form" class="form form-horizontal" autocomplete="off">
        <div class="row">
          <rask-tree-selector aid="omradenSelector"
            class="col-2"
            label="Område"
            [autoSort]="false"
            [items]="omradenItems"
            [required]="false"
            [manualItemSync]="true"
            [syncOnClear]="true">
          </rask-tree-selector>
          <rask-tree-selector aid="selectProduktgrupp"
            class="col-2"
            label="Handelssortimentsgrupp/handelssortiment"
            [items]="hsItems"
            [required]="false"
            [manualItemSync]="true"
            [syncOnClear]="true">
          </rask-tree-selector>
          <rask-datepicker aid="inputPeriodFrom" class="col-1 datepicker" [(ngModel)]="searchFilter.periodstart" [allowInvalidInput]="true"
            label="FR.O.M. *" [minDate]="minDate" [maxDate]="searchFilter.periodslut" [onlyMonths]="true" name="periodFrom"
            [raskRule]="validation.fromDate" ruleContainerId="validationContainer">
          </rask-datepicker>
          <rask-datepicker aid="inputPeriodTom" class="col-1 datepicker" [(ngModel)]="searchFilter.periodslut" [allowInvalidInput]="true"
            label="T.O.M. *" [minDate]="searchFilter.periodstart || minDate" [onlyMonths]="true" name="periodTom"
            [raskRule]="validation.tomDate" ruleContainerId="validationContainer">
          </rask-datepicker>
          <div class="col d-flex pt-3">
            <rask-button
              aid="buttonSok"
              color="secondary"
              [disabled]="!searchParamsValid()"
            (click)="loadProduktionsmal()">Visa</rask-button>
            <rask-button
              aid="buttonClear"
              color="secondary"
              negative
            (click)="clearProduktionsmalParams()">Rensa</rask-button>
          </div>
        </div>
        <rask-validation-message-container id="validationContainer">
        </rask-validation-message-container>
      </form>
    </ng-container>
  }
  <ng-container>
    @if (produktionsmal) {
      <rask-produktionsmal-matris
        [produktionsmal]="produktionsmal">
      </rask-produktionsmal-matris>
    }
  </ng-container>
</rask-page>
